<template>
  <div>
    <button type="button" @click="onClick()" class="btn btn-outline-brand1">{{ $t(i18nMessage) }}</button>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
import { RouteLocationRaw } from 'vue-router';

export default defineComponent({
  name: 'ButtonCancel',
  props: {
    i18nMessage: {
      type: String,
      default: 'common.cancel'
    },
    to: {
      type: [String, Object] as PropType<RouteLocationRaw|string>
    }
  },
  methods: {
    onClick() {
      if (this.to) {
        this.$router.push(this.to)
      } else {
        this.$emit('clicked')
      }
    }
  }
});
</script>
